module.exports = __webpack_public_path__ + "img/message_@@2x.cfe0e78f.png";